import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-file-copy",
  "use": "gw-file-copy-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-file-copy\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M16 1H5c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1Zm.59 4.59 4.83 4.83c.37.37.58.88.58 1.41V21c0 1.1-.9 2-2 2H8.99C7.89 23 7 22.1 7 21l.01-14c0-1.1.89-2 1.99-2h6.17c.53 0 1.04.21 1.42.59ZM16 12h4.5L15 6.5V11c0 .55.45 1 1 1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol